export const styles = {
  portalBox: { display: "flex", minHeight: "100vh" },
  mainComponent: { flexGrow: 1, pt: 2 },
};
